import { scope } from '../../constants';

export const GET_AUTHOR = `${scope}GET_AUTHOR`;
export const SET_AUTHOR = `${scope}SET_AUTHOR`;
